module.exports = __webpack_public_path__ + "static/img/history.5298bee5.png";